import { gql } from '@apollo/client';

export default gql`
  query getVoucherDetails($voucherAlias: String!) {
    findVoucherByReferenceAndMarket(reference: $voucherAlias) {
      alias
      type
      value
      balance
      currency
      status
      customerEmail
      firstName
      lastName
      salesPeriodStart
      salesPeriodEnd
      travelPeriodStart
      travelPeriodEnd
      createdBy
      createdAt
      updatedBy
      updatedAt
      activatedAt
      inactivatedAt
      payments {
        amount
        currency
        status
        bookingReference
      }
      description
      language
      associatedPNR
      replacedByVoucher
      associatedVoucher
      originalSalesPeriodEnd
      originalTravelPeriodEnd
    }
  }
`;
